import { BaseResponse } from "../../../objects/common/baseResponse";
import { CanadianCurrencyCode } from "../../../objects/currencyExchange/canadianCurrencyCode";
import { CurrencyService } from "../../../services/currencyService";
import { Injectable } from "@angular/core";
import { ProductService } from "../../../services/productService";
import { Tariff } from "../../../objects/tariffs/tariff";
import { ProductSearchRequest } from "../../../objects/requests/productSearchRequest";
import { Product } from "../../../objects/products/product";
import { SearchResponse } from "../../../objects/responses/searchResponse";


@Injectable()
export class DefaultTariffResolver {

    constructor(private productService: ProductService) {
    }

    public resolve(): Promise<BaseResponse<SearchResponse<Product>>> {

        return this.productService.search(new ProductSearchRequest({
            SearchType:4,
            Top: 10,
            Skip: 0,
            RequestType: 1
        }));
    }

}


// WEBPACK FOOTER //
// ./app/components/calculator/resolvers/default-tarff.resolver.ts